import { render, staticRenderFns } from "./CancelInvite.vue?vue&type=template&id=6b739377"
import script from "./CancelInvite.vue?vue&type=script&lang=js"
export * from "./CancelInvite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports